import { Button, MenuItem } from "@mui/material";

import { useSetup } from "../../SetupLife.context";

import { BenefitsPolicyVigencyType, IBenefitsPolicy, IBenefitsPolicyRegion } from "../../SetupLife.types";
import { ButtonDelete, Row, SelectForm, Title } from "./BenefitsPolicy.styled";

import { locationOptions } from "v2/pages/MissingDataFormulary/MissingDataMultistep/helper";

interface IProps {
  benefitsPolicy: IBenefitsPolicy;
  handleChange: (payload: Partial<IBenefitsPolicy>) => void;
}

export function BenefitsPolicyRegion({ benefitsPolicy, handleChange }: IProps) {
  const { setup } = useSetup();
  const { benefitsPolicyByGeographicRegion } = benefitsPolicy;

  /** Opções possíveis da coluna de Região. */
  // const regionOptions = ["SÃO PAULO", "CURITIBA"] as const;
  const regionOptions = locationOptions.map(location => location.state);
  /** Opções possíveis da coluna de Plano. */
  // const planOptions = ["PLAN_A", "PLAN_B", "PLAN_C"] as const;
  const planOptions: string[] = [];

  /** Função responsável especificamente por receber os valores alterados e formatar corretamente para handleChange. */
  function handleUpdateRole(payload: Partial<IBenefitsPolicyRegion>, index: number) {
    const updatedPayload = benefitsPolicyByGeographicRegion.map((r, i) => i === index ? { ...r, ...payload } : r);

    handleChange({ ...benefitsPolicy, benefitsPolicyByGeographicRegion: updatedPayload });
  }

  /** Função responsável por remover campo da array de regras de roles. */
  function handleRemoveRole(index: number) {
    const updatedPayload = benefitsPolicyByGeographicRegion.filter((_r, i) => i !== index);

    return handleChange({ ...benefitsPolicy, benefitsPolicyByGeographicRegion: updatedPayload });
  }

  /** Função responsável por adicionar novo campo vazio à array de roles. */
  function handleAddRole() {
    const newRole = { roleName: undefined, planName: undefined };

    return handleChange({ ...benefitsPolicy, benefitsPolicyByGeographicRegion: [...benefitsPolicyByGeographicRegion, newRole] });
  }

  return (
    <>
      <Title>Região geográfica</Title>
      {benefitsPolicyByGeographicRegion.map((benefit, index) => (
        <Row style={{ alignItems: "center"}}>
          <SelectForm
            label="Região"
            value={benefit.roleName}
            onChange={(e) => handleUpdateRole({ roleName: e.target.value as string }, index)}
          >
            {regionOptions.sort().map(option => (
              <MenuItem key={option} value={option} disabled={benefitsPolicyByGeographicRegion.map(b => b.roleName).includes(option)}>{option}</MenuItem>
            ))}
          </SelectForm>
          <SelectForm
            label="Negociação"
            value={benefit.planName}
            onChange={(e) => handleUpdateRole({ planName: e.target.value as string }, index)}
          >
            {benefitsPolicy.negotiations.map(negotiation => (
              <MenuItem key={negotiation} value={negotiation} disabled={benefitsPolicyByGeographicRegion.map(b => b.planName).includes(negotiation)}>{negotiation}</MenuItem>
            ))}
          </SelectForm>
          <ButtonDelete color="error" onClick={() => handleRemoveRole(index)} />
        </Row>
      ))}
      <Button onClick={handleAddRole}>+ Adicionar</Button>
    </>
  );
}
